/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useStateValue } from "../Context/StateProvider";
import { getAllUsers, getAllArtists, getAllAlbums, getAllSongs } from "../Api";
import { actionType } from "../Context/reducer";
import { FaUsers } from "react-icons/fa";
import { GiLoveSong, GiMusicalNotes } from "react-icons/gi";
import { RiStarFill } from "react-icons/ri";
import { bgColors } from "../utils/styles";
//creating internal component
export const Dashboardcard = ({ icon, name, count }) => {
  const [bg_Color, _] = useState(
    bgColors[parseInt(Math.random() * bgColors.length)]
  );
  return (
    <div
      style={{ background: `${bg_Color}` }}
      className="p-4 w-40 gap-3 h-auto rounded-lg shadow-md flex flex-col items-center justify-center"
    >
      {icon}
      <p className="text-xl text-textColor font-semibold  ">{name}</p>
      <p className="text-xl text-textColor">{count}</p>
    </div>
  );
};

const Dashboardhome = () => {
  const [{ allUsers, allSongs, allArtists, allAlbums }, dispatch] =
    useStateValue();
  useEffect(() => {
    if (!allUsers) {
      getAllUsers().then((data) => {
        dispatch({
          type: actionType.SET_ALL_USERS,
          allUsers: data.data,
        });
      });
    }

    if (!allArtists) {
      getAllArtists().then((data) => {
        dispatch({
          type: actionType.SET_ALL_ARTISTS,
          allArtists: data.data,
        });
      });
    }

    if (!allAlbums) {
      getAllAlbums().then((data) => {
        dispatch({
          type: actionType.SET_ALL_ALBUMS,
          allAlbums: data.album,
        });
      });
    }

    if (!allSongs) {
      getAllSongs().then((data) => {
        dispatch({
          type: actionType.SET_SONGS,
          allSongs: data.songs,
        });
      });
    }
  }, []);
  return (
    <div className="w-full p-6 flex  items-center justify-evenly  flex-wrap ">
      <Dashboardcard
        icon={<FaUsers className="text-2xl text-textColor" />}
        name={"Users"}
        count={allUsers?.length > 0 ? allUsers?.length : 0}
      />
      <Dashboardcard
        icon={<RiStarFill className="text-2xl text-textColor" />}
        name={"Artists"}
        count={allArtists?.length > 0 ? allArtists?.length : 0}
      />
      <Dashboardcard
        icon={<GiMusicalNotes className="text-2xl text-textColor" />}
        name={"Albums"}
        count={allAlbums?.length > 0 ? allAlbums?.length : 0}
      />
      <Dashboardcard
        icon={<GiLoveSong className="text-2xl text-textColor" />}
        name={"Songs"}
        count={allSongs?.length > 0 ? allSongs?.length : 0}
      />
    </div>
  );
};
export default Dashboardhome;
